class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper-banner', {
      speed: 500,
      slidesPerView: 1.3,
      spaceBetween: 16,
      loop: true,
      centeredSlides: true,
      navigation: {
        prevEl: ".c-swiper-banner-prev",
        nextEl: ".c-swiper-banner-next",
        hiddenClass: "",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 34,
          loop: true,
        }
      },
    })
  

    const swiperExterior = new Swiper('.c-swiper-exterior', {
      speed: 500,
      spaceBetween: 20,
      centeredSlides: true,
      autoplay: {
        delay: 5000,  
      },
      pagination: {
        el: ".s-access-swiper__page",
        clickable: true,
      },
    })

    const swiperMessage = new Swiper('.c-swiper-message', {
      speed: 500,
      loop: true,
      centeredSlides: true,
      slidesPerView: 1.2,
      spaceBetween: 24,
      navigation: {
        prevEl: ".c-swiper-message-prev",
        nextEl: ".c-swiper-message-next",
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 3.5,
        }
      },
    })

    const swiperStaffContainer = document.querySelector('.c-swiper-staff');
    if (swiperStaffContainer) {
      const slides = swiperStaffContainer.querySelectorAll('.swiper-slide');

      if (window.innerWidth >= 768 && slides.length < 4) {
        $('.c-swiper-staff').css({
          'margin-left': '0px',
        });
        $('.c-swiper-staff ul').css({
          'display': 'flex',
          'column-gap': '3rem',
          'justify-content': 'center',
        });
        $('.c-swiper-staff ul li').css({
          'width': '30rem',
        });
        $('.c-p-staff__prev').css({
          'display': 'none',
        });
        $('.c-p-staff__next').css({
          'display': 'none',
        });
      } else {
        const swiperStaff = new Swiper('.c-swiper-staff', {
          speed: 500,
          centeredSlides: true,
          slidesPerView: 1.2,
          spaceBetween: 20,
          loop: true,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            prevEl: ".c-swiper-staff-prev",
            nextEl: ".c-swiper-staff-next",
          },
          breakpoints: {
            768: {
              loop: false,
              centeredSlides: false,
              slidesPerView: 3.3,
              spaceBetween: 30,
            }
          },
        });
      }
    }

    
    // リサイズイベントにも対応する
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768 && slides.length < 4) {
        swiperStaff.disable(); // Swiperを無効にする
      } else {
        swiperStaff.enable(); // Swiperを再有効にする
      }
    });
    
    // const swiperStaff = new Swiper('.c-swiper-staff', {
    //   speed: 500,
    //   centeredSlides: true,
    //   slidesPerView: 1.2,
    //   spaceBetween: 20,
    //   autoplay: {
    //     delay: 5000,  
    //   },
    //   navigation: {
    //     prevEl: ".c-swiper-staff-prev",
    //     nextEl: ".c-swiper-staff-next",
    //   },

    //   breakpoints: {
    //     768: {
    //       centeredSlides: false,
    //       slidesPerView: 3.3,
    //       spaceBetween: 30,
    //     }
    //   },
    // })

  }
}